import {
  init,
  browserTracingIntegration,
  feedbackIntegration,
} from '@sentry/vue';
import packageJson from '../../package.json';

const ignoreErrors = [
  // Erros de navegação
  'NavigationDuplicated',
  'Avoided redundant navigation to current location: "/login".',

  // Erros específicos da aplicação
  'Configuração invalida.',
  "NotAllowedError: play() failed because the user didn't interact with the document first.",
  '[vuex] do not mutate vuex store state outside mutation handlers.',
  'isNetworkError is not defined',
  'Non-Error promise rejection captured with value: undefined',
  'this.voiceCampaignsAgent.forEach is not a function',
  'this.agentWhatsappCampaigns.forEach is not a function',
];

const sentry = (Vue, router) => {
  const isDev = process.env.NODE_ENV === 'development';
  const isProd = process.env.NODE_ENV === 'production';

  const config = {
    Vue,
    dsn: 'https://938b6682785a17d29395101d7fbf630f@o229689.ingest.us.sentry.io/4508059995996160',
    integrations: [
      browserTracingIntegration({
        router,
        tracingOrigins: isProd ? [/^https:\/\/weon\.com\.br/] : ['localhost'],
        maxTransactionSpans: 5,
        startTransactionOnLocationChange: false,
        startTransactionOnPageLoad: false,
        instrumentNavigation: false, // Desativa rastreamento de navegação
        instrumentRoutes: false, // Desativa rastreamento de rotas
      }),
      feedbackIntegration({
        triggerLabel: 'Relatar um problema',
        formTitle: 'Relatar um problema',
        formDescription:
          'Por favor, descreva o problema que você está enfrentando ou sugira uma melhoria.',
        submitButtonLabel: 'Enviar',
        cancelButtonLabel: 'Cancelar',
        closeButtonLabel: 'Fechar',
        addScreenshotButtonLabel: 'Adicionar screenshot',
        removeScreenshotButtonLabel: 'Remover screenshot',
        nameLabel: 'Nome',
        emailLabel: 'E-mail',
        messageLabel: 'Descreva o problema',
        messagePlaceholder: 'Digite sua mensagem aqui',
        namePlaceholder: 'Digite seu nome aqui',
        emailPlaceholder: 'Digite seu email aqui',
        isRequiredLabel: '*',
        autoInject: false,
        showBranding: false,
        colorScheme: '#fff',
      }),
    ],
    environment: process.env.NODE_ENV,
    release: packageJson.version,
    ignoreErrors,
    maxBreadcrumbs: 5,
    sendDefaultPii: false,
    sampleRate: 0.1,
    tracesSampleRate: 0.1,
    autoSessionTracking: false,
    beforeSend(event) {
      // Captura apenas erros críticos
      if (event.level !== 'error') {
        return null;
      }

      return event;
    },
  };

  return init(config);
};

// Domínios permitidos para o feedback (Relatar um problema) precisa tá registrado no Sentry em: https://weon.sentry.io/settings/projects/new-agent/
const allowedDomains = [
  'ademicon.weon.com.br',
  'acertonline.weon.com.br',
  'fgctba.weon.com.br',
  'weon5.weon.com.br',
  'valorem5m1.weon.com.br',
  'opentech5.weon.com.br',
  'inspirar5.weon.com.br',
  'develop.weon.com.br',
  'brk.weon.com.br',
];

export const isAllowedDomain = (url) => {
  if (!url) return false;
  if (process.env.NODE_ENV === 'development') return true;
  return allowedDomains.some((domain) => url.includes(domain));
};

export default sentry;

// Usage

/*
========= exemplo de captura de evento customizado =========

Sentry.captureEvent({
    message: 'Problema de conexão WebRTC',
    level: 'warning',
    user: {
        agentId,
        agentName,
        email,
        useWebRTC,
        orgName: name,
        orgDescription: description
    },
    tags: {
        'evento': 'problemWebRTC'
    },
    extra: {
        error: value
    },
})

// Adiciona dados de contexto customizados
Sentry.setContext("Operação", {
  id: "12345",
  status: "Falha",
});

// Adiciona informações de um usuário
Sentry.setUser({
  id: "usuario123",
  username: "joao",
  email: "joao@example.com"
});

// Lança um erro com o contexto adicional
Sentry.captureException(new Error('Erro com contexto extra'));
*/
